import { useQuery } from "react-query"
import { AxiosError } from "axios"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import MyAlert from "@common-utils/MyAlert"
import React, { useState } from "react"
import MyCard from "@common-utils/MyCard"
import GlobalHelper from "@common-helpers/GlobalHelper"
import { IGetConsultantsDeclarationsVoyantsResponseModel } from "./core/_models"
import { getConsultantsDeclarationsVoyants } from "./core/_requests"
import { Link, useNavigate } from "react-router-dom"
import MyDateMonthYearField from "@common-utils/fields/MyDateMonthYearField"
import { toast } from "react-toastify"
import { ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING } from "../routing/routing-endpoints"
import VoyantsMonthVueSiege from "./_VoyantsMonthVueSiege"
import VoyantsMonthVueHorsSiege from "./_VoyantsMonthHorsSiege"
import useUser from "../../../hooks/useUser"

const REACT_QUERY_KEY_GET_DECLARATIONS_SALARIE_VOYANTS = "REACT_QUERY_KEY_GET_DECLARATIONS_VOYANTS"
const REACT_QUERY_KEY_GET_DECLARATIONS_ST_VOYANTS = "REACT_QUERY_KEY_GET_DECLARATIONS_ST_VOYANTS"

const GestionProductionDeclarationsVoyants = () => {
     const navigate = useNavigate()
     const [date, setDate] = useState<string>()
     const { isAdministratif } = useUser()

     // Request voyants salariés
     const declarationsSalarieVoyantsQuery = useQuery<IGetConsultantsDeclarationsVoyantsResponseModel[], AxiosError>(REACT_QUERY_KEY_GET_DECLARATIONS_SALARIE_VOYANTS, () =>
          getConsultantsDeclarationsVoyants("salarie").then(r => r.data)
     )

     // Request voyants ST
     const declarationsSousTraitantVoyantsQuery = useQuery<IGetConsultantsDeclarationsVoyantsResponseModel[], AxiosError>(REACT_QUERY_KEY_GET_DECLARATIONS_ST_VOYANTS, () =>
          getConsultantsDeclarationsVoyants("st").then(r => r.data)
     )

     // In case results
     return (
          <div className={"d-flex justify-content-center"}>
               <div className={"w-100 w-lg-75 w-xxl-70"}>
                    <div className={"mb-5"}>
                         <MyCard>
                              <MyCard.Header>Déclarations des salariés</MyCard.Header>
                              <MyCard.Body>
                                   <>
                                        {declarationsSalarieVoyantsQuery.isFetching && (
                                             <div className={"text-center p-5"}>
                                                  <MySimpleSpinner size={"xl"} />
                                             </div>
                                        )}

                                        {!declarationsSalarieVoyantsQuery.isFetching && declarationsSalarieVoyantsQuery.isError && (
                                             <MyAlert type={"danger"} classNames={"mb-4"}>
                                                  <>
                                                       <span className={"me-2"}>{declarationsSalarieVoyantsQuery.error?.response?.data?.detail}</span>
                                                       <button className={"btn btn-sm btn-danger"} onClick={() => declarationsSalarieVoyantsQuery.refetch()}>
                                                            Recharger
                                                       </button>
                                                  </>
                                             </MyAlert>
                                        )}

                                        {/* Month cards */}
                                        {!declarationsSalarieVoyantsQuery.isFetching && !declarationsSalarieVoyantsQuery.isError && declarationsSalarieVoyantsQuery.data && (
                                             <>
                                                  <div className={"row"}>
                                                       {declarationsSalarieVoyantsQuery.data?.map((item, key) => (
                                                            <div className={"col-6 col-sm-3 col-md-3 mb-xl-0 mb-4"} key={key}>
                                                                 <MyCard>
                                                                      <MyCard.Header isCollapseIconShown={false}>
                                                                           <span className={"fas fa-calendar-day me-2 fs-3"}></span>
                                                                           <Link
                                                                                to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                                                                                state={{ mois: item.mois.parseZone().format("YYYY-MM-DD"), contrat: "salarie" }}
                                                                                className={"text-dark text-hover-primary"}
                                                                           >
                                                                                {GlobalHelper.firstLetterUppercase(item.mois.parseZone().format("MMM YYYY"))}
                                                                           </Link>
                                                                      </MyCard.Header>
                                                                      <MyCard.Body>
                                                                           {isAdministratif() ? (
                                                                                <VoyantsMonthVueSiege item={item.voyants} mois={item.mois} contrat={"salarie"} />
                                                                           ) : (
                                                                                <VoyantsMonthVueHorsSiege item={item.voyants} mois={item.mois} contrat={"salarie"} />
                                                                           )}
                                                                      </MyCard.Body>
                                                                 </MyCard>
                                                            </div>
                                                       ))}
                                                  </div>

                                                  <div className="d-flex align-items-center my-5">
                                                       <div className="border-bottom border-secondary mw-50 w-100"></div>
                                                       <span className="fw-bold border-secondary fs-7 mx-2">OU</span>
                                                       <div className="border-bottom border-secondary mw-50 w-100"></div>
                                                  </div>

                                                  {/* Choose month */}
                                                  <div className="d-flex justify-content-center">
                                                       <div className={"w-100 w-sm-50 w-lg-30 d-flex"}>
                                                            <MyDateMonthYearField name={"date"} value={date} onChange={setDate} placeholder={"Choisissez un mois"} />
                                                            <button
                                                                 type="submit"
                                                                 className="btn btn-sm btn-outline btn-outline-dark ms-2"
                                                                 onClick={() => {
                                                                      if (!date || date === "") {
                                                                           toast.error("Veuillez saisir un mois")
                                                                      } else {
                                                                           navigate(ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING, {
                                                                                state: { mois: date + "-01", contrat: "salarie" },
                                                                           })
                                                                      }
                                                                 }}
                                                            >
                                                                 <i className="fas fa-search text-dark"></i>
                                                            </button>
                                                       </div>
                                                  </div>
                                             </>
                                        )}
                                   </>
                              </MyCard.Body>
                         </MyCard>

                         <div className="separator separator-dashed my-5" />

                         <MyCard>
                              <MyCard.Header>Déclarations des sous traitants</MyCard.Header>
                              <MyCard.Body>
                                   {declarationsSousTraitantVoyantsQuery.isFetching && (
                                        <div className={"text-center p-5"}>
                                             <MySimpleSpinner size={"xl"} />
                                        </div>
                                   )}

                                   {!declarationsSousTraitantVoyantsQuery.isFetching && declarationsSousTraitantVoyantsQuery.isError && (
                                        <MyAlert type={"danger"} classNames={"mb-4"}>
                                             <>
                                                  <span className={"me-2"}>{declarationsSousTraitantVoyantsQuery.error?.response?.data?.detail}</span>
                                                  <button className={"btn btn-sm btn-danger"} onClick={() => declarationsSousTraitantVoyantsQuery.refetch()}>
                                                       Recharger
                                                  </button>
                                             </>
                                        </MyAlert>
                                   )}

                                   {/* Month cards */}
                                   {!declarationsSousTraitantVoyantsQuery.isFetching &&
                                        !declarationsSousTraitantVoyantsQuery.isError &&
                                        declarationsSousTraitantVoyantsQuery.data && (
                                             <>
                                                  <div className={"row"}>
                                                       {declarationsSousTraitantVoyantsQuery.data?.map((item, key) => (
                                                            <div className={"col-6 col-sm-3 col-md-3 mb-xl-0 mb-4"} key={key}>
                                                                 <MyCard>
                                                                      <MyCard.Header isCollapseIconShown={false}>
                                                                           <span className={"fas fa-calendar-day me-2 fs-3"}></span>
                                                                           <Link
                                                                                to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                                                                                state={{ mois: item.mois.parseZone().format("YYYY-MM-DD"), contrat: "st" }}
                                                                                className={"text-dark text-hover-primary"}
                                                                           >
                                                                                {GlobalHelper.firstLetterUppercase(item.mois.format("MMM YYYY"))}
                                                                           </Link>
                                                                      </MyCard.Header>
                                                                      <MyCard.Body>
                                                                           {isAdministratif() ? (
                                                                                <VoyantsMonthVueSiege item={item.voyants} mois={item.mois} contrat={"st"} />
                                                                           ) : (
                                                                                <VoyantsMonthVueHorsSiege item={item.voyants} mois={item.mois} contrat={"st"} />
                                                                           )}
                                                                      </MyCard.Body>
                                                                 </MyCard>
                                                            </div>
                                                       ))}
                                                  </div>

                                                  <div className="d-flex align-items-center my-5">
                                                       <div className="border-bottom border-secondary mw-50 w-100"></div>
                                                       <span className="fw-bold border-secondary fs-7 mx-2">OU</span>
                                                       <div className="border-bottom border-secondary mw-50 w-100"></div>
                                                  </div>

                                                  {/* Choose month */}
                                                  <div className="d-flex justify-content-center">
                                                       <div className={"w-100 w-sm-50 w-lg-30 d-flex"}>
                                                            <MyDateMonthYearField name={"date"} value={date} onChange={setDate} placeholder={"Choisissez un mois"} />
                                                            <button
                                                                 type="submit"
                                                                 className="btn btn-sm btn-outline btn-outline-dark ms-2"
                                                                 onClick={() => {
                                                                      if (!date || date === "") {
                                                                           toast.error("Veuillez saisir un mois")
                                                                      } else {
                                                                           navigate(ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING, {
                                                                                state: {
                                                                                     mois: date + "-01",
                                                                                     contrat: "st",
                                                                                },
                                                                           })
                                                                      }
                                                                 }}
                                                            >
                                                                 <i className="fas fa-search text-dark"></i>
                                                            </button>
                                                       </div>
                                                  </div>
                                             </>
                                        )}
                              </MyCard.Body>
                         </MyCard>
                    </div>

                    <MyAlert type={"primary"} classNames={"mb-4"}>
                         <div>
                              Vous pouvez retrouver les anciennes déclarations au format Excel directement dans la partie document de la fiche consultant sous l'onglet{" "}
                              <b>"Anciennes Déclarations d'Activité format Excel"</b>.
                         </div>
                    </MyAlert>
               </div>
          </div>
     )
}

export default GestionProductionDeclarationsVoyants
